import { render, staticRenderFns } from "./PlaceholdersForm.vue?vue&type=template&id=8eca040c&"
import script from "./PlaceholdersForm.vue?vue&type=script&lang=js&"
export * from "./PlaceholdersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports